export default "__VITE_ASSET__CODC0BTE__"